import { useAppDispatch } from '@/hooks';
import { useLogout } from '@/hooks/useLogout';
import { useUserInfo } from '@/hooks/useUserInfo';
import { useGetUserInfoQuery, useGetUserWalletsQuery } from '@/store/api/userApi';
import { setChipsModalOpen, setPasswordModalOpen } from '@/store/slices/uiSlice';
import toast from 'react-hot-toast';
import {
  FaUser,
  FaWallet,
  FaHistory,
  FaChartLine,
  FaGift,
  FaCogs,
  FaLock,
  FaPowerOff,
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const ProfileDropdown = () => {
  const dispatch = useAppDispatch();
  useGetUserInfoQuery(undefined, { pollingInterval: 5000 });
  useGetUserWalletsQuery(undefined, { pollingInterval: 5000 });

  const { handleLogout, isLoading } = useLogout();
  const {
    isDemoAccount,
    username,
    mainBalance,
    withdrawableBalance,
    exposureBalance,
    bonusBalance,
    loggedIn,
  } = useUserInfo();
  return (
    <div className="w-[240px] bg-primary rounded-md text-black py-3 text-[11px] font-medium max-h-[90vh] overflow-auto scrollbar-hide">
      {/* Header */}
      <div className="px-3 font-bold text-[14px] mb-2">
        Welcome, {isDemoAccount ? 'Demo' : username}
      </div>

      {/* Balance Section */}
      <div className="space-y-1 px-3 mb-2">
        <Row label="Main Balance :" value={String(mainBalance)} />
        <Row label="Withdrawable :" value={String(withdrawableBalance)} />
        <Row label="Bonus :" value={bonusBalance} />
        <Row label="Exposure :" value={String(exposureBalance)} />
      </div>

      {/* Menu */}
      <div className="space-y-[2px]">
        <Menu icon={<FaUser />} text="Personal Profile" path="/profile" />
        <Menu icon={<FaWallet />} text="Make a Deposit" path="/deposit" />
        <Menu icon={<FaWallet />} text="Withdraw Funds" path="/withdraw" />
        <Menu icon={<FaHistory />} text="Manual Deposit Report" path="/deposit-report" />
        <Menu icon={<FaHistory />} text="Manual Withdraw Report" path="/withdraw-report" />
        {/* <Menu icon={<FaGift />} text="Active Bonus Report" path="/bonus-report" /> */}
        <Menu icon={<FaHistory />} text="Account Statement" path="/account-statement" />
        <Menu icon={<FaChartLine />} text="Profit / Loss Report" path="/pl-report" />
        <Menu icon={<FaHistory />} text="Bet History" path="/bet-history" />
        <Menu icon={<FaGift />} text="Bonus Report" path="/bonus-report" />
        <Menu icon={<FaUser />} text="My Referrals" path="/referrals" />
        {/* <Menu icon={<FaCogs />} text="Chip Settings" />
        <Menu icon={<FaLock />} text="Change Password" /> */}
        <div
          onClick={() => {
            if (!loggedIn || isDemoAccount) {
              toast.error('PleaseLOGIN OR REGISTER From Real User');
              return;
            }
            dispatch(setChipsModalOpen(true));
          }}
          className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-white"
        >
          <span className="text-[12px]">
            <FaCogs />
          </span>
          <span>Chip Settings</span>
        </div>
        <div
          onClick={() => {
            if (!loggedIn || isDemoAccount) {
              toast.error('PleaseLOGIN OR REGISTER From Real User');
              return;
            }
            dispatch(setPasswordModalOpen(true));
          }}
          className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-white"
        >
          <span className="text-[12px]">
            <FaLock />
          </span>
          <span>Change Password</span>
        </div>

        {/* Logout (highlighted) */}
        <div
          onClick={handleLogout}
          className="flex items-center gap-2 px-3 py-2 bg-white cursor-pointer hover:bg-white"
        >
          <FaPowerOff />
          <span>Logout</span>
        </div>
      </div>
    </div>
  );
};

/* Balance Row */
function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between">
      <span>{label}</span>
      <span className="font-bold">{value}</span>
    </div>
  );
}

/* Menu Item */
function Menu({ icon, text, path }: { icon: React.ReactNode; text: string; path?: string }) {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        path && navigate(path);
      }}
      className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-white"
    >
      <span className="text-[12px]">{icon}</span>
      <span>{text}</span>
    </div>
  );
}

export default ProfileDropdown;
